import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class Ng2FittextDirective {
    constructor(el) {
        this.el = el;
        this.activateOnResize = true;
        this.container = null;
        this.activateOnInputEvents = false;
        this.minFontSize = 7;
        this.maxFontSize = 1000;
        /* Deprecated */
        this.useMaxFontSize = true;
        this.fontSizeChanged = new EventEmitter();
        this.fontSize = 1000;
        this.speed = 1.05;
        this.done = false;
    }
    setFontSize(fontSize) {
        if (this.isVisible() && !this.isDone()) {
            if (fontSize < this.minFontSize) {
                fontSize = this.minFontSize;
            }
            if (fontSize > this.maxFontSize) {
                fontSize = this.maxFontSize;
            }
            this.fontSize = fontSize;
            this.fontSizeChanged.emit(fontSize);
            this.el.nativeElement.style.setProperty('font-size', fontSize.toString() + 'px');
        }
    }
    getFontSize() {
        return this.fontSize;
    }
    calculateFontSize(fontSize, speed) {
        return Math.floor(fontSize / speed);
    }
    checkOverflow(parent, children) {
        return (this.hasXAxisOverflow(parent, children) ||
            this.hasYAxisOverflow(parent, children));
    }
    hasXAxisOverflow(parent, children) {
        return children.scrollWidth - parent.clientWidth > 0;
    }
    hasYAxisOverflow(parent, children) {
        return children.clientHeight - parent.clientHeight > 0;
    }
    onResize(event) {
        this.done = false;
        if (this.activateOnResize && this.fittext) {
            if (this.activateOnInputEvents && this.fittext) {
                this.setFontSize(this.getStartFontSizeFromHeight());
            }
            else {
                this.setFontSize(this.getStartFontSizeFromWeight());
            }
            this.ngAfterViewInit();
        }
    }
    onInputEvents(event) {
        this.done = false;
        if (this.activateOnInputEvents && this.fittext) {
            this.setFontSize(this.getStartFontSizeFromHeight());
            this.ngAfterViewInit();
        }
    }
    ngOnInit() {
        this.done = false;
        this.el.nativeElement.style.setProperty('will-change', 'content');
        this.ngAfterViewInit();
    }
    ngAfterViewInit() {
        if (this.isVisible() && !this.isDone()) {
            if (this.fittext) {
                if (this.hasOverflow()) {
                    if (this.fontSize > this.minFontSize) {
                        // iterate only until font size is bigger than minimal value
                        this.setFontSize(this.calculateFontSize(this.fontSize, this.speed));
                        this.ngAfterViewInit();
                    }
                }
                else {
                    this.done = true;
                }
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.modelToWatch) {
            // change of model to watch - call ngAfterViewInit where is implemented logic to change size
            setTimeout(() => {
                this.done = false;
                this.setFontSize(this.maxFontSize);
                this.ngAfterViewInit();
            });
        }
    }
    ngAfterViewChecked() {
        if (this.fontSize > this.minFontSize) {
            this.setFontSize(this.getStartFontSizeFromHeight());
            this.ngAfterViewInit();
        }
    }
    getStartFontSizeFromHeight() {
        return this.container
            ? this.container.clientHeight
            : this.el.nativeElement.parentElement.clientHeight;
    }
    getStartFontSizeFromWeight() {
        return this.container
            ? this.container.clientWidth
            : this.el.nativeElement.parentElement.clientWidth;
    }
    isDone() {
        return this.done;
    }
    isVisible() {
        return this.getStartFontSizeFromHeight() > 0;
    }
    hasOverflow() {
        return this.container
            ? this.checkOverflow(this.container, this.el.nativeElement)
            : this.checkOverflow(this.el.nativeElement.parentElement, this.el.nativeElement);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: Ng2FittextDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.6", type: Ng2FittextDirective, selector: "[fittext]", inputs: { fittext: "fittext", activateOnResize: "activateOnResize", container: "container", activateOnInputEvents: "activateOnInputEvents", minFontSize: "minFontSize", maxFontSize: "maxFontSize", useMaxFontSize: "useMaxFontSize", modelToWatch: "modelToWatch" }, outputs: { fontSizeChanged: "fontSizeChanged" }, host: { listeners: { "window:resize": "onResize($event)", "input": "onInputEvents($event)" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: Ng2FittextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fittext]',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { fittext: [{
                type: Input,
                args: ['fittext']
            }], activateOnResize: [{
                type: Input,
                args: ['activateOnResize']
            }], container: [{
                type: Input,
                args: ['container']
            }], activateOnInputEvents: [{
                type: Input,
                args: ['activateOnInputEvents']
            }], minFontSize: [{
                type: Input,
                args: ['minFontSize']
            }], maxFontSize: [{
                type: Input,
                args: ['maxFontSize']
            }], useMaxFontSize: [{
                type: Input,
                args: ['useMaxFontSize']
            }], modelToWatch: [{
                type: Input,
                args: ['modelToWatch']
            }], fontSizeChanged: [{
                type: Output
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], onInputEvents: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class Ng2FittextModule {
    static forRoot() {
        return {
            ngModule: Ng2FittextModule,
            providers: [],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: Ng2FittextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.6", ngImport: i0, type: Ng2FittextModule, declarations: [Ng2FittextDirective], imports: [CommonModule], exports: [Ng2FittextDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: Ng2FittextModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: Ng2FittextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [Ng2FittextDirective],
                    exports: [Ng2FittextDirective],
                    imports: [CommonModule],
                }]
        }] });

/*
 * Public API Surface of lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Ng2FittextDirective, Ng2FittextModule };
